import React from "react";
import { HiOutlineLink } from "react-icons/hi";

const UpdateRecordingModal = ({
  showUpdateModal,
  setShowUpdateModal,
  recordingLink,
  setRecordingLink,
  onRecordingUpdate,
  selectedClassId,
  setSelectedClassId,
  isDarkMode = true,
}) => {
  if (!showUpdateModal) return null;

  const handleClose = () => {
    setShowUpdateModal(false);
    if (setSelectedClassId) {
      setSelectedClassId(null);
    }
    setRecordingLink("");
  };

  return (
    <div 
      className={`fixed inset-0 z-[100] flex items-center justify-center ${isDarkMode ? 'bg-black/60' : 'bg-black/20'} backdrop-blur-md transition-opacity duration-300 p-4`} 
      onClick={handleClose}
    >
      <div 
        className={`${isDarkMode ? 'bg-[#0f0f0f]' : 'bg-white'} rounded-xl md:rounded-2xl shadow-2xl w-full max-w-md flex flex-col transition-all duration-300 transform scale-100`} 
        style={{ fontFamily: "Inter, sans-serif" }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className={`px-4 md:px-6 py-3 flex-shrink-0 border-b ${isDarkMode ? 'border-[#1a1a1a]' : 'border-gray-100'}`}>
          <div className="flex items-center justify-between">
            <h3 className={`text-lg md:text-xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
              Update Recording Link
            </h3>
            <button
              onClick={handleClose}
              className={`w-7 h-7 md:w-8 md:h-8 rounded-lg flex items-center justify-center transition-all duration-200 ${isDarkMode ? 'text-gray-400 hover:text-white hover:bg-[#1a1a1a]' : 'text-gray-400 hover:text-gray-700 hover:bg-gray-100'} focus:outline-none`}
            >
              <svg
                className="w-4 h-4 md:w-5 md:h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Body */}
        <form onSubmit={(e) => { e.preventDefault(); onRecordingUpdate(e); }} className="flex-1 overflow-y-auto px-4 md:px-6 py-4 space-y-4">
          <div className="space-y-1.5 md:space-y-2">
            <label className={`block text-xs md:text-sm font-medium ${isDarkMode ? 'text-white' : 'text-gray-700'}`}>
              Recording Link
            </label>
            <div className="relative">
              <input
                type="url"
                placeholder="https://..."
                className={`border-none w-full h-9 md:h-11 pl-3 md:pl-4 pr-8 md:pr-10 py-1.5 md:py-2 rounded-lg text-xs md:text-sm transition-colors ${isDarkMode ? 'bg-[#1a1a1a] text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FDCF08]' : 'bg-white border text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FDCF08]'}`}
                style={isDarkMode ? { backgroundColor: '#1a1a1a' } : {}}
                value={recordingLink}
                onChange={(e) => setRecordingLink(e.target.value)}
                required
              />
              <span className={`absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                <HiOutlineLink size={18} />
              </span>
            </div>
          </div>
        </form>

        {/* Footer */}
        <div className={`px-3 md:px-6 py-2.5 md:py-3 flex flex-col sm:flex-row items-stretch sm:items-center justify-end gap-2 border-t flex-shrink-0 ${isDarkMode ? 'border-[#1a1a1a]' : 'border-gray-100'}`}>
          <button
            type="button"
            onClick={handleClose}
            className={`h-9 md:h-11 px-3 md:px-4 py-1.5 md:py-2 rounded-lg font-medium text-xs md:text-sm transition-all duration-200 order-2 sm:order-1 ${isDarkMode ? 'bg-[#1a1a1a] text-white hover:bg-[#2a2a2a]' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="h-9 md:h-11 px-3 bg-[#FDCF08] text-black font-semibold rounded-lg flex items-center justify-center gap-1.5 md:gap-2 text-xs md:text-sm hover:bg-[#f0c000] focus:outline-none focus:ring-2 focus:ring-[#FDCF08] focus:ring-offset-2 transition-all duration-200 order-1 sm:order-2"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateRecordingModal;